import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThreeProvider } from './contexts/ThreeContext';
import { PinToBoardProvider } from './contexts/PinToBoardContext';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';
import ProtectedRoute from './components/ProtectedRoute';
import './styles/App.css';

function App() {
  return (
    <AuthProvider>
      <ThreeProvider>
        <PinToBoardProvider>
        <Router>
          <div className="app">
            <Routes>
            {/* Landing page as root */}
            <Route path="/" element={<LandingPage />} />
            
  
            {/* Protected routes */}


            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Catch all other routes and redirect to overview */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </div>
        </Router>
        </PinToBoardProvider>
      </ThreeProvider>
    </AuthProvider>
  );
}

export default App;
